import type { SiteConfig } from '@/types'

export const siteConfig: SiteConfig = {
    name: 'ConcreTrack',
    description: "Betontemperatur-Monitoring für Baustellen: Sensoren direkt im Frischbeton, Frühwarnung vor Temperaturrissen und prüffähige Dokumentation für WU-Beton, Bodenplatten und massige Bauteile in Deutschland, Österreich und der Schweiz.",
    url: 'https://concretrack.com',
    locale: 'de_DE',
    ogImage: 'https://concretrack.cdn.modulify.website/images/concretrack-social.jpg',
    loginUrl: 'https://concretrack.com/login',
    links: {
        linkedin: 'https://www.linkedin.com/company/concretrack'
    }
}
